// Definição para o modal de busca de Títulos Originais (A Pagar, Aberto)
// Variação para busca de Títulos Financeiros como referência
// Factory function - recebe idEmpresa como parâmetro

export const criarConfigBuscaTituloOriginal = (idOrganizacao) => ({
  label: 'Título Original',
  placeholder: 'ID ou Parceiro...',
  titulo: 'Pesquisar Título Original (A Pagar - Aberto)',
  endpointApi: 'TitulosFinanceiros',
  idField: 'idTituloFinanceiro',
  displayField: 'idTituloFinanceiro',
  descField: 'idTituloFinanceiro',
  camposFiltro: [
    { label: 'ID ou Parceiro', model: 'buscaLivre', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idTituloFinanceiro', width: '15%' },
    { header: 'Vencimento', dataField: 'dataVencimento', width: '25%', tipo: 'data' },
    { header: 'Saldo Devedor', dataField: 'saldoDevedor', width: '60%', tipo: 'moeda' }
  ],
  filtrosFixos: {
    idOrganizacao,
    lstTipoTitulo: 'FIN_TPTITULO1', // A Pagar
    lstStatusTitulo: 'ST_TITULO_FIN1' // Aberto
  }
})
